<template>
  <div class="mt-4">
    <div>
      <h1>NIH Recovery Act Impact Reports</h1>
      <p>
        For over a century, NIH has been at the forefront of medical research,
        improving public health and directing funding to research institutions
        in communities across the Nation. Thus, NIH was well positioned to
        utilize the $10.4 billion provided by the Recovery Act (FY 2009 and
        2010) to invest in transformative research, accelerate the progress of
        ongoing projects, and support the biomedical workforce in ways that
        would not have been possible otherwise. These Impact Reports illustrate
        how NIH has used ARRA funds to advance science, train scientists, enrich
        science education, and improve the diagnosis, prevention, and treatment
        of diseases. These reports only represent a subset of the more than
        12,000 grants that have been awarded through ARRA. In addition, these
        Impact Reports complement the
        <a :href="`?reportName=investment`"
          >NIH Recovery Act Investment Reports</a
        >, which highlight NIH ARRA-funded projects that are addressing major
        health topics in the Nation
      </p>
    </div>
    <div v-if="serviceFailure">
      <b-alert show variant="danger">{{ message }}</b-alert>

      <b-button variant="outline-primary" :href="`/recovery`"
        >Go To NIH Recovery Act Archive</b-button
      >
    </div>
    <div id="btable" class="overflow-auto" v-else>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="impact-reports-table"
        align="right"
      ></b-pagination>

      <b-table
        striped
        responsive
        tableClass="cat-table"
        id="impact-reports-table"
        :busy.sync="isBusy"
        :fields="fields"
        :items="impactReports"
        :per-page="perPage"
        :current-page="currentPage"
        :outlined="true"
      >
        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell()="data">
          <a :href="`?reportName=impact&id=${data.item.id}`">
            {{ data.item.reportName }}
          </a>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import { data } from "@/shared";
import { SERVICE_UNAVAILABLE_ERROR_MSG } from "@/shared/config.js";
export default {
  name: "ImpactReports",
  data() {
    return {
      isBusy: false,
      impactReports: [],
      serviceFailure: false,
      message: SERVICE_UNAVAILABLE_ERROR_MSG,
      rows: 0,
      fields: [
        {
          key: "InvestmentName",
          label: "Report Title"
        }
      ],
      currentPage: 1,
      perPage: 10
    };
  },
  async created() {
    await this.getImpactReportData();
  },

  methods: {
    async getImpactReportData() {
      this.impactReports = [];

      this.isBusy = true;
      this.impactReports = await data.getImpacts();

      if (!this.impactReports.length) {
        this.serviceFailure = true;
      } else {
        this.rows = this.impactReports.length;
      }
      this.isBusy = false;
    }
  }
};
</script>

